import _ from 'lodash';
import { RouteConfig } from 'vue-router';

import { NAME } from '../constants';
import OtevreneZakazky from './OtevreneZakazky.vue';
import RozpracovaneZakazky from './RozpracovaneZakazky.vue';
import RozpracovanostMechaniku from './RozpracovanostMechaniku.vue';
import VyhodnoceniMechaniku from './VyhodnoceniMechaniku.vue';
import VyhodnoceniMechanikuZakazky from './VyhodnoceniMechanikuZakazky.vue';
import OdpisPP from './OdpisPP.vue';
import NormocasOdpis from './NormocasOdpis.vue';
import VynosCV from './VynosCV.vue';
import VynosND from './VynosND.vue';
import ZakazkaVymaz from './ZakazkaVymaz.vue';
import ZakazkaND from './ZakazkaND.vue';
import VozidlaDZM from './VozidlaDZM.vue';
import PrehledTrzebDlePlatbyZaObdobi from './PrehledTrzebDlePlatbyZaObdobi.vue';
import PrehledTrzebDilnyDleDokladuAZpusobuPlatby from './PrehledTrzebDilnyDleDokladuAZpusobuPlatby.vue';
import PrehledPracProTiskCarKodu from './PrehledPracProTiskCarKodu.vue';
import TiskKoduWCasu from './TiskKoduWCasu.vue';
import TiskPracovnichPrukazek from './TiskPracovnichPrukazek.vue';
import KnihaJizd from './KnihaJizd.vue';
import VozidlaAutopujcovny from './VozidlaAutopujcovny.vue';

export const children: RouteConfig[] = _.map([
	{ name: 'OtevreneZakazky', path: 'OtevreneZakazky', component: OtevreneZakazky },
	{ name: 'RozpracovaneZakazky', path: 'RozpracovaneZakazky', component: RozpracovaneZakazky },
	{ name: 'RozpracovanostMechaniku', path: 'RozpracovanostMechaniku', component: RozpracovanostMechaniku },
	{ name: 'VyhodnoceniMechaniku', path: 'VyhodnoceniMechaniku', component: VyhodnoceniMechaniku },
	{
		name: 'VyhodnoceniMechanikuZakazky',
		path: 'VyhodnoceniMechanikuZakazky',
		component: VyhodnoceniMechanikuZakazky,
	},
	{ name: 'OdpisPP', path: 'OdpisPP', component: OdpisPP },
	{ name: 'NormocasOdpis', path: 'NormocasOdpis', component: NormocasOdpis },
	{ name: 'VynosCV', path: 'VynosCV', component: VynosCV },
	{ name: 'VynosND', path: 'VynosND', component: VynosND },
	{ name: 'ZakazkaVymaz', path: 'ZakazkaVymaz', component: ZakazkaVymaz },
	{ name: 'ZakazkaND', path: 'ZakazkaND', component: ZakazkaND },
	{ name: 'VozidlaDZM', path: 'VozidlaDZM', component: VozidlaDZM },
	{
		name: 'PrehledTrzebDlePlatbyZaObdobi',
		path: 'PrehledTrzebDlePlatbyZaObdobi',
		component: PrehledTrzebDlePlatbyZaObdobi,
	},
	{
		name: 'PrehledTrzebDilnyDleDokladuAZpusobuPlatby',
		path: 'PrehledTrzebDilnyDleDokladuAZpusobuPlatby',
		component: PrehledTrzebDilnyDleDokladuAZpusobuPlatby,
	},
	{
		name: 'PrehledPracProTiskCarKodu',
		path: 'PrehledPracProTiskCarKodu',
		component: PrehledPracProTiskCarKodu,
	},
	{
		name: 'TiskKoduWCasu',
		path: 'TiskKoduWCasu',
		component: TiskKoduWCasu,
	},
	{
		name: 'TiskPracovnichPrukazek',
		path: 'TiskPracovnichPrukazek',
		component: TiskPracovnichPrukazek,
	},
	{
		name: 'KnihaJizd',
		path: 'KnihaJizd',
		component: KnihaJizd,
	},
	{
		name: 'VozidlaAutopujcovny',
		path: 'VozidlaAutopujcovny',
		component: VozidlaAutopujcovny,
	},
], (route) => ({ ...route, meta: { objectName: NAME } }));
